

export const userAgreement ="# **NivoWork 用户协议**  \n" +
  "### 更新日期：**2025年4月8日**  \n" +
  "### 生效日期：**2025年4月8日**  \n" +
  "\n" +
  "亲爱的用户，欢迎您使用我们的 **NivoWork 智能会议产品**！  \n" +
  "在使用本产品前，请您务必仔细阅读并理解本协议的全部内容，尤其是以加粗方式提示的条款。当您开始使用本产品，即表示您已同意本协议。\n" +
  "\n" +
  
  "\n" +
  "## 一、服务内容  \n" +
  "### 1.1 服务范围  \n" +
  "我们通过网页、小程序、SDK、API 等形式，向您提供基于人工智能技术的会议记录、纪要整理、摘要提取等会议辅助服务。  \n" +
  "\n" +
  "### 1.2 服务调整  \n" +
  "我们可能基于法律合规或技术更新，对服务内容进行升级、修改或优化，并通过系统通知或界面提示的方式告知您。\n" +
  "\n" +
  
  "\n" +
  "## 二、账号管理  \n" +
  "### 2.1 账号注册与责任  \n" +
  "您应通过手机号或邮箱注册账号并妥善保管信息，对该账号下的所有活动承担法律责任。  \n" +
  "\n" +
  "### 2.2 账号安全  \n" +
  "若您发现账号被非法使用，应立即通知我们。\n" +
  "\n" +
  
  "\n" +
  "## 三、使用规范  \n" +
  "### 3.1 内容合规  \n" +
  "您承诺在使用过程中遵守国家法律法规，不得提交、传播违法、侵权、虚假、骚扰等信息。  \n" +
  "\n" +
  "### 3.2 网络安全  \n" +
  "您不得利用本服务进行任何危害网络安全的行为。\n" +
  "\n" +
  
  "\n" +
  "## 四、输入与输出内容  \n" +
  "### 4.1 内容责任  \n" +
  "您对使用本服务提交的内容（包括笔记、转录稿、word/pdf 等资料）及生成的会议纪要等结果，承担全部责任。  \n" +
  "\n" +
  "### 4.2 数据使用范围  \n" +
  "我们仅在产品运行必要范围内使用您的输入内容，处理方式与范围详见《[隐私政策](#)》。  \n" +
  "\n" +
  "### 4.3 内容免责声明  \n" +
  "基于大模型生成的内容仅供参考，不构成任何 **法律、医疗、商业等专业建议**，我们不对其完整性、准确性或适用性作出承诺。\n" +
  "\n" +
  
  "\n" +
  "## 五、知识产权  \n" +
  "### 5.1 知识产权归属  \n" +
  "本产品界面、系统、模型提示词及其他相关内容的知识产权归我们所有，受法律保护。  \n" +
  "\n" +
  "### 5.2 使用限制  \n" +
  "未经授权，您不得复制、销售或再分发本产品的系统内容或技术结构，但可自由使用或分享通过本产品生成的结果。\n" +
  "\n" +
  
  "\n" +
  "## 六、隐私保护  \n" +
  "### 6.1 数据处理原则  \n" +
  "我们高度重视数据隐私保护，严格依据国家法律和《[隐私政策](#)》处理您的数据。  \n" +
  "\n" +
  "### 6.2 用户权利  \n" +
  "您可以随时行使访问、更正、删除等权利，具体方式详见《隐私政策》说明。\n" +
  "\n" +
  
  "\n" +
  "## 七、免责声明  \n" +
  "### 7.1 技术风险提示  \n" +
  "鉴于当前 AI 技术的局限性，我们无法保证服务完全无误或持续可用，由此造成的损失由用户自行承担。\n" +
  "\n" +
  
  "\n" +
  "## 八、协议更新  \n" +
  "### 8.1 更新机制  \n" +
  "我们有权适时调整协议内容，并通过网站或产品界面提示。更新后的条款一经发布即生效。\n" +
  "\n" +
  
  "\n" +
  "## 九、法律适用与争议解决  \n" +
  "### 9.1 管辖与解决方式  \n" +
  "本协议受中华人民共和国法律管辖，若发生争议，均提交我们所在地有管辖权的人民法院解决。\n" +
  "\n" +
  
  "\n" +
  "## 十、联系我们  \n" +
  "如您对本协议内容、产品服务使用，或商务合作有任何疑问与建议，欢迎通过以下方式与我们联系：：  \n" +
    "- **技术支持与产品相关问题**：info@nivowork.com  \n" +
    "- **商务合作与媒体垂询**：service@nivowork.com  \n" +
    "\n" +
  "我们将尽快处理您的问题，并在合理时间内给予答复。  \n";

export const privacyAgreement =
  "# **NivoWork 隐私政策**  \n" +
  "### 更新日期：**2025年4月8日**  \n" +
  "### 生效日期：**2025年4月8日**  \n" +
  "\n" +
  
  "\n" +
  "## 欢迎与承诺  \n" +
  "欢迎您使用 **NivoWork**。我们深知您会议资料的重要性，并郑重承诺：  \n" +
  "**我们会以最高标准保护您的隐私与数据安全。**  \n" +
  "本政策适用于您在使用 NivoWork 产品与服务过程中提供或产生的所有个人与会议相关数据。请在使用服务前，仔细阅读并理解本政策内容。\n" +
  "\n" +
  
  "\n" +
  "## 一、我们如何收集与使用信息  \n" +
  "为提供高质量的纪要生成服务，我们仅收集实现核心功能所必要的数据，包括：  \n" +
  "- **账号信息**：用于身份验证和安全通知，包含手机号或邮箱地址；  \n" +
  "- **输入内容**：包括您上传的会议笔记、录音转录稿、word/pdf 文件等，仅用于会议纪要整理功能的实现，不用于其他用途；  \n" +
  "- **操作记录**：用于安全审计和服务优化，如使用时间、设备型号、IP 地址、浏览器类型等；  \n" +
  "- **用户反馈信息**：用于改进产品体验。  \n" +
  "\n" +
  "**我们不会用于广告推送、商业变现或转让第三方**，除非您主动授权或法律明确要求。\n" +
  "\n" +
  
  "\n" +
  "## 二、我们如何保护您的数据  \n" +
  "我们采取多项技术与管理手段，确保数据安全与完整性，包括但不限于：  \n" +
  "- 全链路 **HTTPS 传输加密**；  \n" +
  "- **中国大陆境内数据服务器存储**；  \n" +
  "- 权限控制与行为审计机制；  \n" +
  "- 安全隔离的调用环境；  \n" +
  "- 服务使用后不进行长期存储，部分内容在处理完成后即自动清除。  \n" +
  "\n" +
  "如出现安全事件，我们将第一时间通知您并采取补救措施。\n" +
  "\n" +
  
  "\n" +
  "## 三、数据使用的限定与说明  \n" +
  "我们承诺：  \n" +
  "- 您的会议内容不会被用于任何未经授权的目的；  \n" +
  "- 未经您的同意，我们不会将数据分享、披露、出售或提供给任何第三方；  \n" +
  "- 我们仅在产品功能运行所必需范围内使用上传数据，遵循数据最小化原则；  \n" +
  "- 我们可能基于去标识化的汇总信息，用于内部产品优化，不涉及任何第三方使用或第三方模型商业化训练。\n" +
  "\n" +
  
  "\n" +
  "## 四、您的权利与控制方式  \n" +
  "您有权：  \n" +
  "- 查看、更正、删除您在系统内的个人数据；  \n" +
  "- 撤回对数据处理的授权；  \n" +
  "- 注销您的账号及关联数据（部分数据因法律或安全审计要求可能暂存）。  \n" +
  "\n" +
  "如需操作，请通过 **“设置 - 意见反馈”** 或联系我们的邮箱处理。\n" +
  "\n" +
  
  "\n" +
  "## 五、政策变更与通知  \n" +
  "若我们对隐私政策进行实质性修改（如处理规则或目的变更），将在官网显著位置或通过弹窗方式进行提示。  \n" +
  "继续使用服务即视为您已同意更新内容。\n" +
  "\n" +
  
  "\n\n"
